export interface RegisterRequest {
  id: string;
  phoneNumber: string;
  name: string;
  gender: 'male' | 'female';
  birthDate: {
    type: 'gregorian' | 'hijri';
    year: number;
    month: number;
    day: number;
  };
  maritalStatus: string;
  fatherName: string;
  grandfather1: string;
  grandfather2: string;
  grandfather3: string;
  region: string;
  occupation: string;
  branch: string;
  educationLevel: string;
  otherEducationLevel: string | null;
  status: 'pending' | 'approved' | 'rejected';
  createdAt: string;
  updatedAt: string;
  processedBy: string | null;
  processedAt: string | null;
  password: string;
  confirmPassword: string;
}

export interface RegisterRequestResponse {
  id: string;
  phone_number: string;
  name: string;
  gender: 'male' | 'female';
  birth_date_type: 'gregorian' | 'hijri';
  birth_date_year: number;
  birth_date_month: number;
  birth_date_day: number;
  marital_status: string;
  father_name: string;
  grandfather1_name: string;
  grandfather2_name: string;
  grandfather3_name: string;
  region: string;
  occupation: string;
  branch: string;
  education_level: string;
  other_education_level: string | null;
  status: 'pending' | 'approved' | 'rejected';
  created_at: string;
  updated_at: string;
  processed_by: string | null;
  processed_at: string | null;
  password: string;
}

export function mapRegisterRequest(response: RegisterRequestResponse): RegisterRequest {
  return {
    id: response.id,
    phoneNumber: response.phone_number,
    name: response.name,
    gender: response.gender,
    birthDate: {
      type: response.birth_date_type,
      year: response.birth_date_year,
      month: response.birth_date_month,
      day: response.birth_date_day
    },
    maritalStatus: response.marital_status,
    fatherName: response.father_name,
    grandfather1: response.grandfather1_name,
    grandfather2: response.grandfather2_name,
    grandfather3: response.grandfather3_name,
    region: response.region,
    occupation: response.occupation,
    branch: response.branch,
    educationLevel: response.education_level,
    otherEducationLevel: response.other_education_level,
    status: response.status,
    createdAt: response.created_at,
    updatedAt: response.updated_at,
    processedBy: response.processed_by,
    processedAt: response.processed_at,
    password: response.password, // Don't show password
    confirmPassword: response.password // Don't show password
  };
}